<div class="dropzone-container" [ngClass]="{ 'has-files': files.length > 0 }">
  <h3>{{ title }}</h3>
  <ngx-dropzone [accept]="accept" [multiple]="multiple" (change)="onSelect($event)">
    <ngx-dropzone-label>
      <p>{{ subtitle }}</p>
      <small *ngIf="accept">Archivos permitidos: {{ accept }}</small>
    </ngx-dropzone-label>

    <ngx-dropzone-preview
      *ngFor="let file of files"
      [removable]="true"
      (removed)="onRemove(file)"
      class="dropzone-preview"
    >
      <ngx-dropzone-label>{{ file.name }}</ngx-dropzone-label>
    </ngx-dropzone-preview>
  </ngx-dropzone>
</div>
